import * as React from 'react';

const PencilEditIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          stroke="#00B3E6"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.44 6.72l3.2 3.2-8.32 8.32h-3.2v-3.2z" />
      </g>
    </svg>
  );
};

export default React.memo(PencilEditIcon);
